<div class="d-flex flex-column flex-md-row mb-3 ml-3 mr-3">
  <div class="h3">{{ headline | i18next }}</div>
  <div class="ml-auto bd-highlight">
    @if ((filterMy && !isPartner) && isAdmin) {
      <button name="add-subscription" class="btn btn-outline-primary" [routerLink]="['/subscriptions', 'select-product']" >{{ 'customer_subscription_new_button' | i18next }}</button>
    }
    @if ((!filterMy && isPartner) && isAdmin) {
      <button name="add-subscription" class="btn btn-outline-primary" [routerLink]="['/subscriptions', 'select-product']" >{{ 'partner_customer_subscription_new_button' | i18next }}</button>
    }
    @if (isSubscriptionsInitialized && isPartner && !isCspOne && this.filterMy && this.isAdmin) {
        <div class="d-flex flex-column">
          <button name="add-subscription" class="btn btn-outline-primary" [routerLink]="['/do', 'one-trial']" >{{ 'partner_create_nfr_one_btn' | i18next }}</button>
          <button name="add-subscription" class="btn btn-link" [routerLink]="['/partner', 'how-nfr-one-works']" ><i class="fas fa-info-circle red mr-2"></i>{{ 'nfr_one_prepare_headline' | i18next }}</button>
        </div>
    }
  </div>
</div>

@if (isPartner) {
  <div>
    <div class="d-inline d-md-none">
      <div ngbDropdown>
        <button class="btn bg-transparent" id="dropdownBasic1" ngbDropdownToggle>
          <span>{{ headline | i18next }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button class="dropdown-item" routerLink="/subscriptions/my">
            <span>{{ 'nav_subscriptions_my' | i18next }}</span>
          </button>
          <button class="dropdown-item" routerLink="/subscriptions/customer">
            <span>{{ 'nav_subscriptions_customer' | i18next }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row d-none d-md-inline">
      <div class="col">
        <ul class="nav link-navigation">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/subscriptions/my">{{'nav_subscriptions_my' | i18next}}</a>
          </li>
          <li class="nav-item ml-2" routerLinkActive="active">
            <a class="nav-link" routerLink="/subscriptions/customer">{{'nav_subscriptions_customer' | i18next}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
}

<app-filter (searchFilterChanged)="doFilter($event)"
  [placeholder]="'customer_subscription_search' | i18next"
  [multiFilterOptions]="dropdownFilterOptions"
  (multiFilterChanged)="onMultiFilterChanged($event)"
  multiFilterDisplay="chip"
  filterType="both"
  (checkboxFilterChanged)="showExpired($event)"
  [checkboxFilterText]="'filter_expired_subscriptions' | i18next"
  [showDropdown]="dropdownFilterOptions.length > 0"
></app-filter>

@if (subscriptions && subscriptions.length === 0) {
  <app-no-content-message t="no_subscriptions"></app-no-content-message>
}

<div class="row align-items-stretch mt-2">
  @for (lic of subscriptions; track lic) {
    <app-subscription-card class="col-xs-12 col-md-6 col-lg-6 mb-3" [subscription]="lic" [detaillist]="true">
      @if (lic.isValid) {
        <button [name]="lic.name + '-details'" class="btn btn-outline-primary" [routerLink]="['/subscriptions', lic.appliance_id]">{{'app_details' | i18next}}</button>
      }
      @if (!lic.isValid) {
        <div upgrade>
          @if (lic.isOneTrial) {
            <button class="btn btn-outline-primary" (click)="doUpgradeExpiredOneTrial(lic.appliance_id)">{{'subscription_upgrade_plan' | i18next}}</button>
          }
        </div>
      }
    </app-subscription-card>
  }
</div>
